import { render, staticRenderFns } from "./AppAvatar.vue?vue&type=template&id=2fd2aa0a"
import script from "./AppAvatar.vue?vue&type=script&lang=js"
export * from "./AppAvatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports